import { Component } from "react";
import { DocumentButton, LabelContainer, LongLabelContainer, ShortBlueButton } from "../assets/style";
import { Box } from "@mui/material";

export default function FormLongLabel(props: { title: any, content?: any }) {
    const { title, content } = props
    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        flexWrap: "wrap",
        // maxWidth: "300px",
    };

    return (
        <Box sx={containerStyle}>
            <LongLabelContainer>
                {title + ": "}
            </LongLabelContainer>
            <LongLabelContainer>
                {content}
            </LongLabelContainer>
        </Box>
    );
}
